
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $4f6704803a4ced5c$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3E07t\",\"index.e91e6b05.js\",\"6kxAx\",\"../Hatsune-Miku-vocaloids-30622078-935-1023.372f250a.jpg\"]"));

var $2aa2988d0b33484a$exports = {};
$2aa2988d0b33484a$exports = "#version 300 es\nprecision highp float;\n#define GLSLIFY 1\n\nuniform float u_time;\nuniform float u_canvasWidth;\nuniform float u_canvasHeight;\nuniform sampler2D u_mikuTexture;\n\nin vec2 v_texCoord;\nout vec4 fragColor;\n\n// See https://thebookofshaders.com/10/\nfloat random (vec2 st) {\n    return fract(sin(dot(st.xy, vec2(12.9898,78.233)))* 43758.5453123);\n}\n\nvec4 boxFade(vec4 inputColor, float boxSize, float period) {\n    float canvasSize = max(u_canvasWidth, u_canvasHeight);\n\n    vec2 uv = gl_FragCoord.xy/vec2(canvasSize, canvasSize);\n    uv.x = floor(uv.x / boxSize) * boxSize;\n    uv.y = floor(uv.y / boxSize) * boxSize;\n\n    float rand = random(uv);\n    float mask = mod(u_time / period, 2.4);\n\n    return rand < mask ? inputColor : vec4(0.0, 0.0, 0.0, 1.0);\n}\n\nvec2 pixellate(vec2 inputVec, float size) {\n    return vec2(\n        floor(inputVec.x / size) * size,\n        floor(inputVec.y / size) * size\n    );\n}\n\nvec4 pixelatedSinWave() {\n    vec2 uv = gl_FragCoord.xy/vec2(u_canvasWidth, u_canvasHeight);\n\n    float amount = 1.0/(u_time * 9.0);\n\n    uv = pixellate(uv, amount);\n\n    //vec4 outputColor = vec4(uv.x, 0., uv.y, 1.0);\n    float dist = distance(uv, vec2(0.5, 0.5));\n    float curve = sin(dist * 60.0);\n    vec4 outputColor = vec4(0.5, 0.1, curve, 1.0);\n    return outputColor;\n\n    float size = 0.01;\n    float period = 1.0;\n\n    fragColor = boxFade(outputColor, size, period);\n}\n\nvec4 miku() {\n    // Get base texture color\n    vec2 uv = v_texCoord;\n    uv.x = uv.x + sin(u_time + uv.x * 30.0) * 0.02;\n\n    // Sample the texture first without effects\n    vec4 texColor = texture(u_mikuTexture, uv);\n\n    return texColor;\n}\n\nvoid main() {\n\n    vec4 texColor = miku();\n\n    // Apply box fade effect\n    float boxSize = 0.02;\n    float period = 2.0;\n    fragColor = boxFade(texColor, boxSize, period);\n}\n";


var $cda5a321842bab3a$exports = {};
$cda5a321842bab3a$exports = new URL("../Hatsune-Miku-vocaloids-30622078-935-1023.372f250a.jpg", import.meta.url).toString();


const $4113a2e7be3e377b$var$canvas = document.getElementById('canvas');
const $4113a2e7be3e377b$var$gl = $4113a2e7be3e377b$var$canvas.getContext('webgl2');
// Load Miku texture
const $4113a2e7be3e377b$var$mikuTexture = $4113a2e7be3e377b$var$gl.createTexture();
// Create a single pixel as initial texture to avoid errors before image loads
$4113a2e7be3e377b$var$gl.bindTexture($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$mikuTexture);
$4113a2e7be3e377b$var$gl.texImage2D($4113a2e7be3e377b$var$gl.TEXTURE_2D, 0, $4113a2e7be3e377b$var$gl.RGBA, 1, 1, 0, $4113a2e7be3e377b$var$gl.RGBA, $4113a2e7be3e377b$var$gl.UNSIGNED_BYTE, new Uint8Array([
    255,
    0,
    255,
    255
]));
const $4113a2e7be3e377b$var$mikuImage = new Image();
$4113a2e7be3e377b$var$mikuImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($cda5a321842bab3a$exports)));
$4113a2e7be3e377b$var$mikuImage.onload = ()=>{
    console.log('Miku image loaded successfully');
    $4113a2e7be3e377b$var$gl.bindTexture($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$mikuTexture);
    $4113a2e7be3e377b$var$gl.texImage2D($4113a2e7be3e377b$var$gl.TEXTURE_2D, 0, $4113a2e7be3e377b$var$gl.RGBA, $4113a2e7be3e377b$var$gl.RGBA, $4113a2e7be3e377b$var$gl.UNSIGNED_BYTE, $4113a2e7be3e377b$var$mikuImage);
    $4113a2e7be3e377b$var$gl.texParameteri($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$gl.TEXTURE_WRAP_S, $4113a2e7be3e377b$var$gl.CLAMP_TO_EDGE);
    $4113a2e7be3e377b$var$gl.texParameteri($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$gl.TEXTURE_WRAP_T, $4113a2e7be3e377b$var$gl.CLAMP_TO_EDGE);
    $4113a2e7be3e377b$var$gl.texParameteri($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$gl.TEXTURE_MIN_FILTER, $4113a2e7be3e377b$var$gl.LINEAR);
    $4113a2e7be3e377b$var$gl.texParameteri($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$gl.TEXTURE_MAG_FILTER, $4113a2e7be3e377b$var$gl.LINEAR);
};
$4113a2e7be3e377b$var$mikuImage.onerror = (err)=>{
    console.error('Failed to load Miku image:', err);
};
// Basic vertex shader (just passes coordinates and texture coordinates)
const $4113a2e7be3e377b$var$vertexShaderSource = `#version 300 es
in vec4 a_position;
out vec2 v_texCoord;
void main() {
    gl_Position = a_position;
    // Convert position from clip space (-1 to +1) to texture coordinates (0 to 1)
    v_texCoord = a_position.xy * -0.5 + 0.5;
}`;
// Compile shader
function $4113a2e7be3e377b$var$createShader(type, source) {
    const shader = $4113a2e7be3e377b$var$gl.createShader(type);
    $4113a2e7be3e377b$var$gl.shaderSource(shader, source);
    $4113a2e7be3e377b$var$gl.compileShader(shader);
    if (!$4113a2e7be3e377b$var$gl.getShaderParameter(shader, $4113a2e7be3e377b$var$gl.COMPILE_STATUS)) {
        console.error($4113a2e7be3e377b$var$gl.getShaderInfoLog(shader));
        $4113a2e7be3e377b$var$gl.deleteShader(shader);
        throw new Error('Shader compilation failed');
    }
    return shader;
}
// Create shader program
const $4113a2e7be3e377b$var$vertexShader = $4113a2e7be3e377b$var$createShader($4113a2e7be3e377b$var$gl.VERTEX_SHADER, $4113a2e7be3e377b$var$vertexShaderSource);
const $4113a2e7be3e377b$var$fragmentShader = $4113a2e7be3e377b$var$createShader($4113a2e7be3e377b$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($2aa2988d0b33484a$exports))));
const $4113a2e7be3e377b$var$program = $4113a2e7be3e377b$var$gl.createProgram();
$4113a2e7be3e377b$var$gl.attachShader($4113a2e7be3e377b$var$program, $4113a2e7be3e377b$var$vertexShader);
$4113a2e7be3e377b$var$gl.attachShader($4113a2e7be3e377b$var$program, $4113a2e7be3e377b$var$fragmentShader);
$4113a2e7be3e377b$var$gl.linkProgram($4113a2e7be3e377b$var$program);
if (!$4113a2e7be3e377b$var$gl.getProgramParameter($4113a2e7be3e377b$var$program, $4113a2e7be3e377b$var$gl.LINK_STATUS)) {
    console.error($4113a2e7be3e377b$var$gl.getProgramInfoLog($4113a2e7be3e377b$var$program));
    throw new Error('Program link failed');
}
// Set up a rectangle covering the entire canvas
const $4113a2e7be3e377b$var$positions = new Float32Array([
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    1,
    1
]);
const $4113a2e7be3e377b$var$positionBuffer = $4113a2e7be3e377b$var$gl.createBuffer();
$4113a2e7be3e377b$var$gl.bindBuffer($4113a2e7be3e377b$var$gl.ARRAY_BUFFER, $4113a2e7be3e377b$var$positionBuffer);
$4113a2e7be3e377b$var$gl.bufferData($4113a2e7be3e377b$var$gl.ARRAY_BUFFER, $4113a2e7be3e377b$var$positions, $4113a2e7be3e377b$var$gl.STATIC_DRAW);
// Set up vertex attributes
const $4113a2e7be3e377b$var$positionAttributeLocation = $4113a2e7be3e377b$var$gl.getAttribLocation($4113a2e7be3e377b$var$program, 'a_position');
$4113a2e7be3e377b$var$gl.enableVertexAttribArray($4113a2e7be3e377b$var$positionAttributeLocation);
$4113a2e7be3e377b$var$gl.vertexAttribPointer($4113a2e7be3e377b$var$positionAttributeLocation, 2, $4113a2e7be3e377b$var$gl.FLOAT, false, 0, 0);
// Get uniform locations
const $4113a2e7be3e377b$var$timeUniformLocation = $4113a2e7be3e377b$var$gl.getUniformLocation($4113a2e7be3e377b$var$program, 'u_time');
const $4113a2e7be3e377b$var$canvasWidthLocation = $4113a2e7be3e377b$var$gl.getUniformLocation($4113a2e7be3e377b$var$program, 'u_canvasWidth');
const $4113a2e7be3e377b$var$canvasHeightLocation = $4113a2e7be3e377b$var$gl.getUniformLocation($4113a2e7be3e377b$var$program, 'u_canvasHeight');
const $4113a2e7be3e377b$var$mikuTextureLocation = $4113a2e7be3e377b$var$gl.getUniformLocation($4113a2e7be3e377b$var$program, 'u_mikuTexture');
// Set up resize handler
function $4113a2e7be3e377b$var$resize() {
    $4113a2e7be3e377b$var$canvas.width = window.innerWidth;
    $4113a2e7be3e377b$var$canvas.height = window.innerHeight;
    $4113a2e7be3e377b$var$gl.viewport(0, 0, $4113a2e7be3e377b$var$canvas.width, $4113a2e7be3e377b$var$canvas.height);
}
window.addEventListener('resize', $4113a2e7be3e377b$var$resize);
$4113a2e7be3e377b$var$resize();
// Animation loop
function $4113a2e7be3e377b$var$draw(time) {
    $4113a2e7be3e377b$var$gl.useProgram($4113a2e7be3e377b$var$program);
    $4113a2e7be3e377b$var$gl.uniform1f($4113a2e7be3e377b$var$timeUniformLocation, time * 0.001); // Convert to seconds
    $4113a2e7be3e377b$var$gl.uniform1f($4113a2e7be3e377b$var$canvasWidthLocation, $4113a2e7be3e377b$var$canvas.width);
    $4113a2e7be3e377b$var$gl.uniform1f($4113a2e7be3e377b$var$canvasHeightLocation, $4113a2e7be3e377b$var$canvas.height);
    // Bind Miku texture to texture unit 0
    $4113a2e7be3e377b$var$gl.activeTexture($4113a2e7be3e377b$var$gl.TEXTURE0);
    $4113a2e7be3e377b$var$gl.bindTexture($4113a2e7be3e377b$var$gl.TEXTURE_2D, $4113a2e7be3e377b$var$mikuTexture);
    $4113a2e7be3e377b$var$gl.uniform1i($4113a2e7be3e377b$var$mikuTextureLocation, 0);
    $4113a2e7be3e377b$var$gl.drawArrays($4113a2e7be3e377b$var$gl.TRIANGLE_STRIP, 0, 4);
    requestAnimationFrame($4113a2e7be3e377b$var$draw);
}
$4113a2e7be3e377b$var$draw(0);


//# sourceMappingURL=index.e91e6b05.js.map
